import { useAppSelector, selectLoginStatus } from "@repo/web-store";
import DescriptionUtil from "./DescriptionUtil";

interface DescriptionWithColumnsProps {
  id: string;
  heading: string;
  informationText: string;
  description: string; 
  isTwoColumn: boolean;
  hideOnLoggedIn?: boolean;
  customClass?: string;
}

export default function DescriptionWithColumns({
  id,
  heading,
  informationText,
  description,
  isTwoColumn,
  hideOnLoggedIn = false,
  customClass,
}: DescriptionWithColumnsProps) {

  return (
    <section
      id={id}
      className={`description-with-columns max-w-[1040px] pb-3 ${customClass ?? ""}`}
    >
      {/* Heading */}
      <h2 className="description-with-columns__heading font-medium text-[18px] text-[#1a1a1a]">
        {heading}
      </h2>

      {/* Information Text */}
      {informationText && (
        <div
          className="description-with-columns__info  pt-2 pb-2 text-[#4d4d4d] text-[14px] [&_a]:text-[#ff6700]
  leading-5 min-[1025px]:text-[16px] min-[1025px]:leading-6"
          dangerouslySetInnerHTML={{ __html: informationText }}
        />
      )}

      {/* Description Columns */}
      {description && (
        <div
          className={
            isTwoColumn
              ? "min-[1025px]:flex min-[1025px]:gap-4"
              : "min-[1025px]:flex min-[1025px]:gap-3"
          }
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}

        <DescriptionUtil targetId={id} hideOnLoggedIn={hideOnLoggedIn} />
      </section>
  );
}